import { UserHealth } from '../models/user-health';
import api from './api';

export const saveUserHealth = async (userHealth: UserHealth) => {
  return await api.post('userHealth', userHealth);
};
